export const normaliseLink = (url: string) => {
  if(url.includes('resource.')) return url
  return url.replace(/.*headbox.com\//, '/');
};
